import React, { useEffect } from 'react';
import { View } from '@dbk/ui-react-utils';
import cx from 'classnames';

import { FormattedMessage } from '@dbk/format';
import MarqueContainer from '../common/marque-container';
import RsaModal from '../common/rsa-modal';
import InternetCheck from './internet-check';
import Alert from '../common/alert';
import Discovery from './discovery';
import AppFooter from './app-footer';
import AppHeader from './app-header';
import AppNav from './app-nav';
import VascoModal from '../../screens/auth/vasco/vasco-modal';
import config from '../../data/settings.json';
import { DASHBOARD_2FA_REGIONS, VASCO_FLOW, EBANKINGWEBUK } from '../../constants';
import AwarenessBannerModal from '../../screens/docsign/subscription/awareness-banner';
import ChatWelcomeScreen from '../../screens/chat/subscription/chat-welcome-screen';
import ChatScreen from '../../screens/chat';
import ChatWidget from '../../components/chat/container';
import ChatNavigation from '../../screens/chat';
import WebSocket from '../chat/web-socket';
import PaymentBanner from '../../screens/payments/payment-psd2-banner';
import SkipMainContent from '../app/skip-main-content';
import AlertManager from '../alert-manager/alert-manager';
import MultiSignNotification from './multi-sign/multi-sign-notification'
import envConfig from '../../../db-env-build';
import DowntimeBanner from '../common/downtime-banner';

const Portal = (props) => {
  const {
    isVasco,
    screen: { isSmall },
    auth: { authorised, dashboardAuthorised, passwordExpired, vascoFlow, langCode, isRMUserGroup },
    ui: {
      title,
      history: {
        currentLocation: { pathname, route },
      },
    },
    marque: { loginDissmiss },
    i18n: { messages },
    config: { regionCode, docsign, chat },
    docsign: { showDocsignBanner, docsignBannerSeen },
    rsa: { rsaAuthorised },
    vascoauthentication: { vascoAuthorised },
    ais: { isBannerVisible },
    auth: { entitlement, entitlementProcessed },
    children,
    chat: { showWelcomeScreen, showChat, closeWS, isChatSelected },
    rmAccess: { rmAuthorised },
    discovery: { visible },
    terms: { isModalOpen },
    alerts: { isAlertModalOpen }
  } = props;

  const isSearchPage = pathname.endsWith('search');
  const isLoginPage = pathname.endsWith('login');
  const isResetPasswordPage = pathname.endsWith('reset-password');
  const isInsightPage = pathname.endsWith('insights');
  const sectionClass = route && route.section ?
    ("section-" + route.section.replace(/\s/g, '')) : ''
  const appCls = cx({

    'footer-menu-padding': authorised && isSmall,
    'side-menu-padding': authorised && !isSmall,
    'no-portfolio-bar': isInsightPage,
    'no-app-header': isSearchPage || isLoginPage,
    'has-marque-bar': !loginDissmiss,

  });

  const pageContentClasses = cx('content', {
    vasco: isVasco,
    isVasco,
  });

  const is2FARegionCode = DASHBOARD_2FA_REGIONS.includes(regionCode);
  const twoFAAuthorised = !is2FARegionCode || (is2FARegionCode && dashboardAuthorised);
  const showAppHeader = authorised && !isSearchPage && twoFAAuthorised && !isResetPasswordPage && !isLoginPage;
  return (
    <View className={'app-container ' + appCls + ' ' + sectionClass}>


      {/* <MarqueContainer /> */}
      {/* <SkipMainContent/> */}
      {authorised && twoFAAuthorised && <AppNav />}
      {/* { !visible && authorised && twoFAAuthorised && <AlertManager /> } */}
      {!visible && authorised && twoFAAuthorised && !isModalOpen && <AlertManager/> }
      
      {showAppHeader && <div className="app-header-placeholder" />}
      <View role="main" id="main-content" className={pageContentClasses}>
      {showAppHeader && !passwordExpired && <AppHeader titleMsg={messages[title]} />}
        {children}

        {/* Add extra padding at bottom for mobile layout */}
        {showAppHeader && <div className="app-header-placeholder" />}
        {showAppHeader && isBannerVisible && <PaymentBanner />}
        {authorised && twoFAAuthorised && <MultiSignNotification visible = {visible}/>}
        {/* { !visible && authorised && twoFAAuthorised && <AlertManager /> } */}

        <RsaModal
          title={<FormattedMessage id="app.token.header.title" />}
          //  title={<FormattedMessage id={messages['app.token.header.title']} />}
          doneLabel={messages['app.common.closeText']}
        />
        {
          config.features.vascoAuth &&
          (entitlementProcessed || vascoFlow === VASCO_FLOW.resetPassword) &&
          <VascoModal />
        }
      </View>
      <div role="contentinfo">
        {!isLoginPage && authorised && <AppFooter />}
      </div>
     
      <Alert />
      <InternetCheck />

      {/* {authorised && chat && showChat &&
        <WebSocket>
          {({close}) => (closeWS ? close : <div />)}
        </WebSocket>
      } */}

      {authorised && chat && (isChatSelected || showChat) && (vascoAuthorised || rsaAuthorised) && <ChatScreen />}

      {/* <WebSocket>
          {({close}) => (closeWS ? close : <div />)}
        </WebSocket>
      <ChatWidget /> */}
      {/* WMCE-3262 : If RM user group is 95, dont display the helpscreens */}
      {/* {langCode === 'en' && authorised && !isRMUserGroup && <Discovery />} */}
      {/* WMCE-56387 Removal of Discovery images */}
      {
        docsign && showDocsignBanner && (rsaAuthorised || vascoAuthorised)
        && !docsignBannerSeen && entitlement.esign_regular_customer &&
        (
          <AwarenessBannerModal />
        )
      }
    </View>
  );
};

export default Portal;  